// Purpose: Recap/analytics API calls
// Caller: recapAction
// Dependencies: utils/xhr
// Main Functions: getRecap
// Side Effects: HTTP GET /recap

import { xhr } from 'utils'

export const getRecap = (params = '', options = {}) =>
  xhr.get(`/recap?${params}`, { timeout: 60000, ...options })
